import { Box } from '@mui/material';

import { CheckboxButton } from '@/components';
import { UsaStates } from '@/constants';
import {
  onboardingActions,
  selectOnboardingStepInputs,
  STEP_IDS,
  useAppDispatch,
  useAppSelector,
} from '@/store';

import { styles } from '../styles';
import { ExtraBold } from './ExtraBold';
import { Footer } from './Footer';
import { Header } from './Header';
import { ModalTitle } from './ModalTitle';

export const UsaCpaStatesForm = () => {
  const dispatch = useAppDispatch();

  const stepInputs = useAppSelector(selectOnboardingStepInputs);
  const { value: states } = stepInputs[STEP_IDS.usaCpaStates];

  const handleChange = (stateCode: string) => {
    const newStates = { ...states };

    if (newStates[stateCode]) {
      delete newStates[stateCode];
    } else {
      newStates[stateCode] = true;
    }
    dispatch(
      onboardingActions.updateStepInputs({
        step: STEP_IDS.usaCpaStates,
        input: newStates,
      }),
    );
  };

  return (
    <Box sx={styles.formContainer}>
      <Header Title={<Title />} />
      <Box sx={styles.formPrimarySection}>
        {Object.entries(UsaStates).map(([key, name]) => (
          <Box key={key} sx={styles.checkboxContainer}>
            <CheckboxButton
              label={name}
              id={key}
              checked={!!states[key]}
              onChange={() => handleChange(key)}
            />
          </Box>
        ))}
      </Box>
      <Footer />
    </Box>
  );
};

const Title = () => {
  return (
    <ModalTitle>
      As a <ExtraBold>CPA</ExtraBold> in the{' '}
      <ExtraBold>United States of America</ExtraBold>, select all states you are
      licensed in.
    </ModalTitle>
  );
};
